module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"PageCatalogConfigurable":{"action":{"choose":"Začít konfigurovat"},"breadcrumbs":{"title":"Konfigurátor"},"backButton":"Krok zpět","title":"Vyberte si co budete konfigurovat?"}}}')
  delete Component.options._Ctor
}
